<template>
  <material-card
    :title="$t('components.plancreationwizard.calculation_term_configuration')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="schedule"
    style="margin-top:30px"
  >
    <v-card-text>
      <v-form :disabled="disabled">
        <v-layout row wrap>
          <v-col cols="12" class="pt-0 pb-0">
            <period-picker
              v-model="generalSettings.PlanSettings.Term"
              :label="$t('globals.term')"
              :rules="[$rules.required]"
              class="required"
              :timeunitTooltip="$t('components.periodpicker.termunit_tooltip')"
              :frequencyTooltip="
                $t('components.periodpicker.frequency_tooltip')
              "
            ></period-picker>
          </v-col>
          <v-col cols="12" sm="12" md="12" class="pt-0 pb-0">
            <due-picker
              :value.sync="generalSettings.PlanSettings.DueDate"
              :daysOfMonth="options.Enums.DayOfMonth"
              :weekDays="options.Enums.WeekDay"
              :dueDays="options.Enums.DueDay"
              :months="options.Enums.Month"
              :weeks="options.Enums.Week"
              :dueTimeUnits="options.Enums.DueTimeUnit"
              :termTimeUnit="generalSettings.PlanSettings.Term.TimeUnit"
              class="required"
            ></due-picker>
          </v-col>
          <v-col xs="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <tooltip-textbox
              :value.sync="generalSettings.PlanSettings.BillingOffset"
              :label="$t('views.plangeneralparameters.billing_offset')"
              :rules="[$rules.requiredInteger]"
              class="required"
              :tooltipText="
                $t('components.plancreationwizard.billing_offset_tooltip')
              "
            ></tooltip-textbox>
          </v-col>
          <v-col xs="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <tooltip-textbox
              :value.sync="generalSettings.PlanSettings.EligibilityOffset"
              :label="$t('views.plangeneralparameters.eligibility_offset')"
              :rules="[$rules.requiredInteger, $rules.equalOrLessThan0]"
              class="required"
              :tooltipText="
                $t('components.plancreationwizard.eligibility_offset_tooltip')
              "
            ></tooltip-textbox>
          </v-col>
        </v-layout>
      </v-form>
    </v-card-text>
  </material-card>
</template>
<script>
import { mapGetters } from "vuex";
import PeriodPicker from "@/components/PeriodPicker";
import DuePicker from "@/components/DuePicker";
import TooltipTextbox from "@/components/TooltipTextbox";

export default {
  components: { PeriodPicker, DuePicker, TooltipTextbox },
  props: ["generalSettings", "disabled"],
  computed: {
    ...mapGetters("plansMembers", ["options"]),
  },
  data() {
    return {
    };
  },
};
</script>
